import { useState, useEffect } from 'react';

const MOBILE_QUERY = '(pointer: coarse) and (max-width: 768px)';

/**
 * Detects mobile device via `pointer: coarse` + max-width 768px.
 * Reactively updates when window is resized or input devices change.
 * Returns false in environments without matchMedia (e.g., jsdom/SSR).
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    return window.matchMedia(MOBILE_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;

    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    // Sync initial value in case SSR/hydration mismatch
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
